import { render, staticRenderFns } from "./messageDetil.vue?vue&type=template&id=209852f6&scoped=true&"
import script from "./messageDetil.vue?vue&type=script&lang=js&"
export * from "./messageDetil.vue?vue&type=script&lang=js&"
import style0 from "./messageDetil.vue?vue&type=style&index=0&id=209852f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209852f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209852f6')) {
      api.createRecord('209852f6', component.options)
    } else {
      api.reload('209852f6', component.options)
    }
    module.hot.accept("./messageDetil.vue?vue&type=template&id=209852f6&scoped=true&", function () {
      api.rerender('209852f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/messageDetil.vue"
export default component.exports